import React from 'react'
import AddPhotos from '../../Components/Vendor/VendorStudios/AddPhotos'
import Footer from '../../Components/Vendor/Footer/Footer'

function AddphotosPage() {
  return (
    <div>
       <AddPhotos/>
       <Footer/>
    </div>
  )
}

export default AddphotosPage
